import { render, staticRenderFns } from "./WorkshopSurvey.vue?vue&type=template&id=51594f43&"
import script from "./WorkshopSurvey.vue?vue&type=script&lang=js&"
export * from "./WorkshopSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports